import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { DateRangePicker } from 'react-dates';
import 'react-dates/initialize';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { change } from 'redux-form';

import { setPersonalizedValues } from '../../../actions/personalized';

import s from 'react-dates/lib/css/_datepicker.css';
import { dateInternationalization, isRTL } from '../../../helpers/formatLocale';
import messages from '../../../locale/messages';
import c from '../../../styles/reactDatesCalendar.css';


class DateRange extends React.Component {
  static propTypes = {
    onChange: PropTypes.any,
    numberOfMonths: PropTypes.number,
    setPersonalizedValues: PropTypes.any,
    formatMessage: PropTypes.any,
    personalized: PropTypes.shape({
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      isOneTotalToggle: PropTypes.bool,
    }),
  };

  constructor(props) {
    super(props);
    this.state = {
      focusedInput: null,
      startDate: null,
      endDate: null,
      isOneTotalToggle: false
    };
  }

  UNSAFE_componentWillMount() {
    const { personalized } = this.props;

    if (personalized != undefined) {
      if (personalized.startDate && personalized.endDate) {
        this.setState({
          startDate: moment(personalized.startDate),
          endDate: moment(personalized.endDate),
        });
        // Restaura el valor del filtro `dates` del formulario (p. ej. al abrir
        // una nueva pestaña con fechas hidratadas desde localStorage).
        this.syncDatesField(personalized.startDate, personalized.endDate);
      }
    }
    if (personalized.isOneTotalToggle) this.setState({ isOneTotalToggle: personalized.isOneTotalToggle })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { personalized } = nextProps;
    if (personalized != undefined) {
      if (personalized.startDate && personalized.endDate) {
        this.setState({
          startDate: moment(personalized.startDate),
          endDate: moment(personalized.endDate),
        });
        this.syncDatesField(personalized.startDate, personalized.endDate);
      }
    }
    if (personalized.isOneTotalToggle) this.setState({ isOneTotalToggle: personalized.isOneTotalToggle })
  }

  // Re-emite el valor del filtro `dates` ('YYYY-MM-DD' AND 'YYYY-MM-DD') en el
  // redux-form indicado por `formName`, para que el filtro de fechas persista
  // aunque el usuario no vuelva a tocar el calendario (nueva pestaña, recarga,
  // navegación). Solo cliente: en SSR el estado del form no se usa.
  syncDatesField = (startDate, endDate) => {
    const { formName, change } = this.props;
    if (typeof window === 'undefined') return;
    if (startDate != null && endDate != null && formName) {
      change(formName, 'dates', `'${moment(startDate).format("YYYY-MM-DD")}' AND '${moment(endDate).format("YYYY-MM-DD")}'`);
    }
  }

  onDatesChange = ({ startDate, endDate }) => {
    const { setPersonalizedValues, formName, change } = this.props;
    this.setState({ startDate, endDate });
    if (startDate != null && endDate != null) {
      setPersonalizedValues({ name: 'startDate', value: moment(startDate).format('YYYY-MM-DD') });
      setPersonalizedValues({ name: 'endDate', value: moment(endDate).format('YYYY-MM-DD') });
      change(formName, 'dates', `'${moment(startDate).format("YYYY-MM-DD")}' AND '${moment(endDate).format("YYYY-MM-DD")}'`);
    } else {
      setPersonalizedValues({ name: 'startDate', value: null });
      setPersonalizedValues({ name: 'endDate', value: null });
      change(formName, 'dates', null);
    }
  }

  onFocusChange = (focusedInput) => {
    this.setState({ focusedInput });
  }

  onClear = () => {
    const { setPersonalizedValues, formName, change } = this.props;
    setPersonalizedValues({ name: 'startDate', value: null });
    setPersonalizedValues({ name: 'endDate', value: null });
    setPersonalizedValues({ name: 'isOneTotalToggle', value: false });
    setPersonalizedValues({ name: 'totalPrice', value: false });
    change(formName, 'dates', null);
    change(formName, 'isOneTotalToggle', false);
    change(formName, 'totalPrice', false);
    this.setState({
      startDate: null,
      endDate: null,
    });
  }

  render() {
    const { focusedInput, startDate, endDate } = this.state;
    const { numberOfMonths, locale, isLoading } = this.props;
    const { formatMessage } = this.props.intl;
    dateInternationalization(locale);
    // Separador de flecha entre fecha de inicio y fin: "Fecha X → Fecha Y".
    // Se invierte en RTL para mantener la dirección de lectura.
    const arrowStyle = isRTL(locale)
      ? { display: 'inline-block', transform: 'scaleX(-1)' }
      : { display: 'inline-block' };
    const rangeSeparator = <span aria-hidden="true" style={arrowStyle}>→</span>;
    return (
      <div>
        <DateRangePicker
          onDatesChange={this.onDatesChange}
          onFocusChange={this.onFocusChange}
          focusedInput={focusedInput}
          startDate={startDate}
          endDate={endDate}
          numberOfMonths={numberOfMonths}
          startDatePlaceholderText={formatMessage(messages?.eligeFechas)}
          endDatePlaceholderText={''}
          customArrowIcon={rangeSeparator}
          hideKeyboardShortcutsPanel
          readOnly
          startDateId={'startDateId'}
          endDateId={'endDateId'}
          transitionDuration={0}
          anchorDirection={isRTL(locale) ? 'right' : 'left'}
          isRTL={isRTL(locale)}
          renderCalendarInfo={(props) => {
            return (
              startDate && endDate && <div className={cx('calClearText', 'calClearTextRTL')} onClick={() => { this.onClear() }}>{formatMessage(messages.clear)}</div>
            )
          }}
        />
      </div>
    );
  }
}

const mapState = state => ({
  personalized: state.personalized,
  locale: state.intl.locale,
  isOneTotalToggle: state.personalized.isOneTotalToggle,
});

const mapDispatch = {
  setPersonalizedValues,
  change
};

// export default injectIntl((connect(mapState, mapDispatch)(DateRange)));
export default injectIntl(withStyles(s, c)(connect(mapState, mapDispatch)(DateRange)));